import { noop } from 'lodash';
import InternalLink from '../../components/link/internal-link';
import NoopLink from '../../components/link/noop-link';
import { navigateToBlog, navigateToForum } from '../../services/navigate-to-section';

export default {
  Link: InternalLink,
  MembersLink: NoopLink,
  ProfileLink: NoopLink,
  FollowingLink: NoopLink,
  FollowersLink: NoopLink,
  SettingsLink: NoopLink,
  NotificationsLink: NoopLink,
  navigateToMembers: noop,
  navigateToProfile: noop,
  navigateToProfileSettings: noop,
  navigateToNotifications: noop,
  navigateToEditPost: location => navigateToForum(location),
  navigateToCreatePost: () => navigateToBlog('/create-post'),
  navigateToMyDrafts: noop,
};



// WEBPACK FOOTER //
// ./app/services/navigation-provider/forum-with-members-area-removed.js